import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBxBolt = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "currentColor",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M5 15h5v6a1 1 0 0 0 1 1c.31 0 .62-.15.81-.41l8-11a1 1 0 0 0 .08-1.04A1 1 0 0 0 19 9h-5V3a1 1 0 0 0-.69-.95c-.41-.13-.86.01-1.12.36l-8 11a1 1 0 0 0-.08 1.04A1 1 0 0 0 5 15Zm7-8.92V10c0 .55.45 1 1 1h4.04L12 17.92V14c0-.55-.45-1-1-1H6.96L12 6.08Z" })
});
export default SvgBxBolt;
